/* eslint-disable react/no-danger */
import React from 'react';
import translate from '../../../../utils/translations';
import ManageBookingSection from './ManageBookingSection/ManageBookingSection';

function hasVasProductFrom(company, vasItems) {
    const vasProduct = vasItems.find((item) => {
        return (
            item?.vasPaymentDetails?.type.substring(0, company.length) ===
                company ||
            item?.vasPaymentDetails?.type === 'ACCIDENTAL_DAMAGE_PROTECTION'
        ); // This is a CSA product but is not prefixed with CSA
    });

    return !!vasProduct;
}

function TripProtectionSection({translations, vasItems}) {
    if (!Array.isArray(vasItems)) {
        return null;
    }

    const hasProductFromCSA = hasVasProductFrom('CSA', vasItems);

    // TODO: Handle EA product when link URLs and their landing pages are ready
    if (hasProductFromCSA) {
        return (
            <ManageBookingSection>
                <div className="trip-protection">
                    <h3>
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.vas.heading'
                        )}
                    </h3>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.inbox.conversation.vas.csa.claims.portal'
                            ),
                        }}
                    />
                    <p
                        dangerouslySetInnerHTML={{
                            __html: translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.inbox.conversation.vas.csa.refundOrCredit'
                            ),
                        }}
                    />
                </div>
            </ManageBookingSection>
        );
    }

    return null;
}

export default TripProtectionSection;
